import React from 'react'
import { PageDescription } from 'shared-compoents/page-description/page-description';
import { PageTitle } from 'shared-compoents/page-title-v2/page-title';
import { IntroSection } from '../style';

interface OnboardingIntroProps {
  title: string;
  description: string;
}

function OnboardingInro({ title, description }: Readonly<OnboardingIntroProps> ) {
  return (
    <IntroSection>
        <PageTitle>{ title }</PageTitle>
        <PageDescription>{ description }</PageDescription>
    </IntroSection>
  )
}

export default OnboardingInro;
